import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.rentos.co.in';

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('rentos_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const requestOTP = (phone) =>
  api.post('/auth/request-otp', { phone });

export const requestRegistrationOTP = (phone) =>
  api.post('/auth/request-registration-otp', { phone });

export const verifyOTP = (phone, otp) =>
  api.post('/auth/verify-otp', { phone, otp });

export const getMe = () =>
  api.get('/auth/me');

export const registerLandlord = (data) =>
  api.post('/landlords/register', data);

// Buildings
export const getBuildings = () =>
  api.get('/buildings/');

export const createBuilding = (data) =>
  api.post('/buildings/', data);

// Units
export const getUnits = (buildingId) =>
  api.get('/units/' + buildingId);

export const createUnit = (data) =>
  api.post('/units/', data);

export const updateUnit = (unitId, data) =>
  api.put('/units/' + unitId, data);

export const deleteUnit = (id) =>
  api.delete('/units/' + id);

// Tenants
export const getTenants = () =>
  api.get('/tenants/');

export const createTenant = (data) =>
  api.post('/tenants/', data);

export const updateTenant = (id, data) =>
  api.put('/tenants/' + id, data);

export const deleteTenant = (id) =>
  api.delete('/tenants/' + id);

export const sendReminder = (tenantId) =>
  api.post('/tenants/' + tenantId + '/remind');

export const tenantMoveOut = (tenantId, data) =>
  api.post('/tenants/' + tenantId + '/moveout', data);

export const getTenantPaymentHistory = (tenantId) =>
  api.get('/tenants/' + tenantId + '/payments');

// Rent status
export const getRentStatus = (buildingId, month) =>
  api.get('/rent-status/' + buildingId + '/' + month);

// Payments
export const getPendingPayments = () =>
  api.get('/payments/pending');

export const approvePayment = (paymentId) =>
  api.post('/payments/' + paymentId + '/approve');

export const rejectPayment = (paymentId, reason) =>
  api.post(`/payments/${paymentId}/reject`, { reason });

export const recordPayment = (data) =>
  api.post('/rent-payments/', data);

export const recordManualPayment = (data) =>
  api.post('/payments/manual', data);

// Arrears Notification
export const getBuildingArrears = (buildingId) =>
  api.get('/buildings/' + buildingId + '/arrears');

export const getTenantArrears = (tenantId) =>
  api.get('/tenants/' + tenantId + '/arrears');

export const remindAllArrears = (buildingId) =>
  api.post('/buildings/' + buildingId + '/remind-arrears');

export default api;
// Deposit payments
export const getDepositPayments = (tenantId) =>
  api.get('/tenants/' + tenantId + '/deposit-payments');

export const recordDepositPayment = (tenantId, data) =>
  api.post('/tenants/' + tenantId + '/deposit-payments', data);

export const deleteDepositPayment = (dpId) =>
  api.delete('/deposit-payments/' + dpId);
